
/* eslint-disable jsx-a11y/label-has-for */
/* eslint-disable react/no-array-index-key */
/* eslint-disable no-alert */
import React from 'react';
// import { Link } from 'react-router';
import classNames from 'classnames';
import { Field, FieldArray, reduxForm, change } from 'redux-form';
import moment from 'moment';
import { v4 as uuidv4 } from 'uuid';
import {
  // dynamicSort,
  friendlyURICharacters,
  getDefaultIcon,
  getQuestDurationHours,
  preloadRequirement,
  replaceSpaces,
  isAutoStreamQuest,
  isSecondaryCreationQuest,
  isStreamingQuest,
  isQuestTimeSetValid,
} from '../../utils/functions';
import { simpleNotification } from '../../utils/notifications';

import {
  getLanguageOptions,
  getCountryOptions,
  getPlatformOptions,
} from './QuestForm/constants/options';

import CustomInput from '../../utils/redux-forms-custom-fields/CustomInput';
import CustomInputCheckbox from '../../utils/redux-forms-custom-fields/CustomInputCheckbox';
import CustomTagField from '../../utils/redux-forms-custom-fields/CustomTagField';
import TiersWhitelist from './QuestForm/TiersWhitelist';
import { arrayDropDownColors } from '../../utils/constants';
import ArrayDropDown from '../../utils/redux-forms-custom-fields/ArrayDropDown';
import './skin.min.css';
import RequiredGames from './QuestForm/RequiredGames';
import TiersTaskMode from './QuestForm/TiersTaskMode';
import { validateQuestForm } from './QuestForm/validators/questFormValidator';
import FAQs from './QuestForm/components/FAQs';
import QuestDescriptions from './QuestForm/components/FAQs';
import Rules from './QuestForm/components/Rules';
import StepsGeneric from './QuestForm/components/UserInfo/StepsGeneric';
import Landing from './QuestForm/components/UserInfo/Landing';
import LogsDisplay from './QuestForm/components/Logs/index';
import EmailSettings from './QuestForm/components/UserInfo/EmailSettings';
import Followers from './QuestForm/components/Followers';
import Requirements from './QuestForm/components/UserInfo/Requirements';
import FormFooter from './QuestForm/components/FormFooter';
import WhiteList from './QuestForm/components/Parameters/WhiteList';
import MemberTiers from './QuestForm/components/Parameters/MemberTiers';
import ViewerTiers from './QuestForm/components/Parameters/ViewerTiers';
import SplitMode from './QuestForm/components/SplitMode/index';
import RankMode from './QuestForm/components/RankMode/index';
import Details from './QuestForm/components/Details/index';
import UploadModal from './QuestForm/modals/UploadModal';

class QuestForm extends React.Component {
  constructor(props) {
    super(props);
    this.props = props;
    this.faqs = [];
    this.questDescriptions = [];
    this.state = {
      activeModal: 0,
      dropzoneActive: false,
      file: '',
      image: '',
      indexIcon: false,
      parametersSubTab: 0,
      pointInQuest: false,
      pointInQuestIcon: false,
      prevGamesPlayed: [],
      subTab: 'landing',
      tab: 'details',
      parametersAwardMode: 0,
      // 成就选择窗口状态
      achievementModal: {
        isOpen: false,
        pointInQuest: null,
        index: null,
        isModifying: false,
        modifyingAchievementId: null
      },
      // Steam 成就相关状态
      steamAchievements: {
        data: [],
        game: {},
        pagination: {},
        stats: {},
        isLoading: false,
        error: null
      }
    };
  }

  UNSAFE_componentWillReceiveProps(nextProps) {

    if (this.props.preSignedUrl.isLoading === true && nextProps.preSignedUrl.isLoading === false) {
      const { data: signedUrl } = nextProps.preSignedUrl;
      this.uploadToS3(this.state.file, signedUrl.preSignedUrl);
    }

    if (this.props.quest && this.props.quest.isCreating === true && nextProps.quest.isCreating === false) {
      if (nextProps.quest.errors.hasError) {
        if (nextProps.quest.errors.code === 'E_QUEST_SLUG_DUPLICATED') {
          this.setState({ tab: 'user-info' });
          this.scrollToSlug();
        }
      }
    }

    if (this.props.quest && this.props.quest.isUpdating === true && nextProps.quest.isUpdating === false) {
      if (nextProps.quest.errors.hasError) {
        if (nextProps.quest.errors.code === 'E_QUEST_SLUG_DUPLICATED') {
          this.setState({ tab: 'user-info' });
          this.scrollToSlug();
        }
      }
    }

    if (this.props.isLoading && !nextProps.isLoading && nextProps.quest) {
      this.setState({ prevGamesPlayed: (nextProps.quest.prevGamesPlayed || []) });
    }

    // 当游戏信息加载完成时，获取Steam成就
    if (!this.props.game?.id && nextProps.game?.id) {
      console.log('游戏ID变化，获取Steam成就:', nextProps.game.id);
      // 预加载Steam成就数据（避免在componentWillReceiveProps中直接调用setState）
      setTimeout(() => {
        this.getSteamGameAchievements(nextProps.game.id);
      }, 0);
    }
  }

  getQuestTypeFlags = () => {
    const { questForm = {} } = this.props;
    //判断当前任务是老的视频直播任务
    const streamingQuest = isStreamingQuest(questForm.values);
    //判断当前任务是否是自动结算直播任务
    const autoStreamingQuest = isAutoStreamQuest(questForm.values);
    //判断当前任务是否是二次创作任务
    const secondaryCreationQuest = isSecondaryCreationQuest(questForm.values);
    //判断当前任务是否是新类型任务
    const isNewTypeQuest = autoStreamingQuest || secondaryCreationQuest;
    //判断当前任务是否是非基础任务
    const isStreamOrNewTypeQuest = streamingQuest || autoStreamingQuest;
    return { streamingQuest, autoStreamingQuest, secondaryCreationQuest, isNewTypeQuest, isStreamOrNewTypeQuest };
  }

  getQuest = (quest) => {
    if (quest.comingSoon) return;

    const { auth: { token }, getQuest } = this.props;

    getQuest(quest.id, true, token);
  }

  onDrop = (files, e) => {
    const file = files && files.length ? files[0] : e[0];
    this.setState({
      dropzoneActive: false,
      file,
    });
    const { image } = this.state;
    const format = file.name.split('.')[1];
    const { auth: { token }, requestUploadCCImageUrl } = this.props;

    const uploadContext = {
      entityType: 'quests',
      entityId: this.props.quest && this.props.quest.id ? this.props.quest.id : undefined,
    };

    if (image === 'banner') {
      requestUploadCCImageUrl('banner', format, token, { ...uploadContext, field: 'banner' });
    } else if (image === 'regular') {
      requestUploadCCImageUrl('regular', format, token, { ...uploadContext, field: 'cover' });
    } else if (image === 'overlay') {
      requestUploadCCImageUrl('overlay', format, token, { ...uploadContext, field: 'overlayImage' });
    } else if (image === 'icon') {
      requestUploadCCImageUrl('icon', format, token, { ...uploadContext, field: 'logo' });
    }

    this.setState({ activeModal: 2 });
  }

  scrollToSlug = () => {
    this.slugE.scrollIntoView({ behavior: 'smooth' });
  }

  submit = (questFormInformation) => {

    const {
      autoStreamingQuest,
      secondaryCreationQuest,
      isNewTypeQuest,
    } = this.getQuestTypeFlags();

    const { game, onSubmit, quest } = this.props;
    const { prevGamesPlayed } = this.state;
    // 创建新对象，避免修改原始表单值
    // 对于需要转换的字段，在复制时进行转换
    const questFormInfo = {
      ...questFormInformation,
      // 转换 campaigns
      campaigns: questFormInformation.campaigns && questFormInformation.campaigns.length > 0
        ? questFormInformation.campaigns.map(q => q?.value)
        : questFormInformation.campaigns,
      // 转换 platforms
      platforms: questFormInformation.platforms
        ? [questFormInformation.platforms.value]
        : questFormInformation.platforms,
      // 转换 countries
      countries: questFormInformation.countries && questFormInformation.countries.length > 0
        ? questFormInformation.countries.map(c => c?.value)
        : questFormInformation.countries,
      // 转换 languages
      languages: questFormInformation.languages && questFormInformation.languages.length > 0
        ? questFormInformation.languages.map(l => l.value)
        : questFormInformation.languages,
    };
    const requiredDateTimeStart = moment(questFormInfo.requiredStartDateTime, 'YYYY-MM-DD');
    const requiredDateTimeEnd = moment(questFormInfo.requiredEndDateTime, 'YYYY-MM-DD');
    const range = requiredDateTimeEnd.diff(requiredDateTimeStart, 'minutes');
    questFormInfo.requiredStreamRangeTime = range;
    questFormInfo.requiredStreamTimeHours = 24;
    if (questFormInfo.requiredStreamTimeMinutes) {
      questFormInfo.requiredStreamTimeMinutes = parseInt(questFormInfo.requiredStreamTimeMinutes, 10);
    }

    if (questFormInfo.paymentAmount) {
      questFormInfo.paymentAmount = parseInt(questFormInfo.paymentAmount, 10);
    }

    if (questFormInfo.dailyEarning) {
      questFormInfo.dailyEarning = parseInt(questFormInfo.dailyEarning, 10);
    }

    if (questFormInfo.miniFollowers) {
      questFormInfo.miniFollowers = parseInt(questFormInfo.miniFollowers, 10);
    }


    if (questFormInfo.viewerTiers && questFormInfo.viewerTiers.length > 0) {
      const isYoutubeVideoQuest = questFormInfo.type === 'youtube-video';
      for (let i = 0; i < questFormInfo.viewerTiers.length; i += 1) {
        questFormInfo.viewerTiers[i].spotsAvailable = parseInt(questFormInfo.viewerTiers[i].spotsAvailable, 10);
        questFormInfo.viewerTiers[i].paymentAmount = parseFloat(questFormInfo.viewerTiers[i].paymentAmount, 10);
        
        // Parse metric field based on quest type
        if (isYoutubeVideoQuest) {
          if (questFormInfo.viewerTiers[i].minimumAveragePlayCount !== undefined) {
            questFormInfo.viewerTiers[i].minimumAveragePlayCount = parseInt(questFormInfo.viewerTiers[i].minimumAveragePlayCount, 10);
          }
        } else {
          if (questFormInfo.viewerTiers[i].minimumAverageViewers !== undefined) {
            questFormInfo.viewerTiers[i].minimumAverageViewers = parseInt(questFormInfo.viewerTiers[i].minimumAverageViewers, 10);
          }
        }
      }
    }

    if (questFormInfo.memberTiers && questFormInfo.memberTiers.length > 0) {
      for (let k = 0; k < questFormInfo.memberTiers.length; k += 1) {
        const { identity, paymentAmount, type } = questFormInfo.memberTiers[k];
        questFormInfo.memberTiers[k] = {
          identity: identity?.trim(),
          paymentAmount: parseFloat(paymentAmount, 10),
          type: type?.trim(),
        };
      }
    }

    if (questFormInfo.splitTiers && questFormInfo.splitTiers.length > 0) {
      //streamDays, streamHours, maxRevenue, prizePool
      for (let i = 0; i < questFormInfo.splitTiers.length; i += 1) {
        if (autoStreamingQuest) {
          questFormInfo.splitTiers[i].streamDays = parseInt(questFormInfo.splitTiers[i].streamDays, 10);
          // questFormInfo.splitTiers[i].streamHours = parseInt(questFormInfo.splitTiers[i].streamHours, 10);
          // 转换分钟为小时，保留两位小数
          const minutesValue = parseInt(questFormInfo.splitTiers[i].streamHours, 10);
          questFormInfo.splitTiers[i].streamHours = parseFloat((minutesValue / 60).toFixed(2));
        } else if (secondaryCreationQuest) {
          questFormInfo.splitTiers[i].totalUploadDays = parseInt(questFormInfo.splitTiers[i].totalUploadDays, 10);
          questFormInfo.splitTiers[i].validUploadCount = parseInt(questFormInfo.splitTiers[i].validUploadCount, 10);
          questFormInfo.splitTiers[i].totalViews = parseInt(questFormInfo.splitTiers[i].totalViews, 10);
        }
        questFormInfo.splitTiers[i].maxRevenue = parseInt(questFormInfo.splitTiers[i].maxRevenue, 10);
        questFormInfo.splitTiers[i].prizePool = parseInt(questFormInfo.splitTiers[i].prizePool, 10);
      }
    }

    if (questFormInfo.rankTiers && questFormInfo.rankTiers.length > 0) {
      //rankUpper, rankLower, watchTime, prize
      for (let i = 0; i < questFormInfo.rankTiers.length; i += 1) {
        questFormInfo.rankTiers[i].rankUpper = parseInt(questFormInfo.rankTiers[i].rankUpper, 10);
        questFormInfo.rankTiers[i].rankLower = parseInt(questFormInfo.rankTiers[i].rankLower, 10);
        if (autoStreamingQuest) {
          // 转换分钟为小时，保留两位小数
          const minutesValue = parseInt(questFormInfo.rankTiers[i].watchTime, 10);
          questFormInfo.rankTiers[i].watchTime = parseFloat((minutesValue / 60).toFixed(2));
        } else if (secondaryCreationQuest) {
          questFormInfo.rankTiers[i].minTotalViews = parseInt(questFormInfo.rankTiers[i].minTotalViews, 10);
        }
        questFormInfo.rankTiers[i].prize = parseInt(questFormInfo.rankTiers[i].prize, 10);
      }
    }

    questFormInfo.type = questFormInfo.type || 'one-time';

    if (questFormInfo.type === 'tiered-one-time' || questFormInfo.type === 'timed') {
      questFormInfo.frequency = 'one-time';
    }

    if (questFormInfo.type === 'tiered-multi-days' || questFormInfo.type === 'paid bounty') {
      questFormInfo.frequency = 'daily';
    }

    if (isNewTypeQuest) {
      questFormInfo.requirePreapproval = true;
      questFormInfo.frequency = 'daily';
      //判断时间
      const { valid, messages } = isQuestTimeSetValid(quest, questFormInfo);
      if (!valid) {
        simpleNotification({
          level: 'error',
          title: 'Time Validation Error',
          message: messages.join(' '),
        });
        return; // 阻止提交
      }
    }

    if (autoStreamingQuest) {
      questFormInfo.twitchAccountRequired = true;
    }

    if (secondaryCreationQuest) {
      questFormInfo.youtubeAccountRequired = true;
      questFormInfo.requirePreapproval = false;
    }

    if (questFormInfo.type === 'youtube-video') {
      questFormInfo.youtubeAccountRequired = true;
      questFormInfo.twitchAccountRequired = false;
    }

    questFormInfo.group = (questFormInfo.group) ? questFormInfo.group : '';

    console.log('questFormInfo', questFormInfo);

    // 新增：验证Steam Achievement requirements
    if (questFormInfo.requirements) {
      const allRequirements = [
        ...(questFormInfo.requirements.beforeStream || []),
        ...(questFormInfo.requirements.duringStream || []),
        ...(questFormInfo.requirements.afterStream || [])
      ];

      const steamAchievementRequirements = allRequirements.filter(req => req.type === 'submit-steam-achievement');
      
      if (steamAchievementRequirements.length > 0) {
        // 检查游戏是否有Steam App ID
        if (!game?.steamAppId) {
          simpleNotification({
            level: 'error',
            title: 'Steam Integration Required',
            message: 'This game must have a Steam App ID to use Steam Achievement requirements.',
          });
          return;
        }

        // 验证每个Steam Achievement requirement
        for (const req of steamAchievementRequirements) {
          if (!req.gameAchievements || req.gameAchievements.length === 0) {
            simpleNotification({
              level: 'error',
              title: 'Steam Achievement Required',
              message: `Please select at least one Steam achievement for requirement "${req.title || 'Steam Achievement'}".`,
            });
            return;
          }
        }
      }
    }

    if (questFormInfo.requirements) {
      if (questFormInfo.requirements.beforeStream) {
        for (let i = 0; i < questFormInfo.requirements.beforeStream.length; i += 1) {
          const req = questFormInfo.requirements.beforeStream[i];
          delete questFormInfo.requirements.beforeStream[i].value;
          if (!req.customIcon || req.icon === getDefaultIcon(req.type, req.subtype, questFormInformation, game)) {
            questFormInfo.requirements.beforeStream[i].icon = false;
          }

          if (req.type === 'display-hashtags' || req.type === 'display-stream-time' || (req.type === 'display-text' && req.subtype === 'game-name')) {
            questFormInfo.requirements.beforeStream[i].title = '';
          }
        }
      }

      if (questFormInfo.requirements.duringStream) {
        for (let i = 0; i < questFormInfo.requirements.duringStream.length; i += 1) {
          const req = questFormInfo.requirements.duringStream[i];
          delete questFormInfo.requirements.duringStream[i].value;
          if (req.icon === getDefaultIcon(req.type, req.subtype, questFormInformation, game)) {
            questFormInfo.requirements.duringStream[i].icon = false;
          }

          if (req.type === 'display-hashtags' || req.type === 'display-stream-time' || (req.type === 'display-text' && req.subtype === 'game-name')) {
            questFormInfo.requirements.duringStream[i].title = '';
          }
        }
      }

      if (questFormInfo.requirements.afterStream) {
        for (let i = 0; i < questFormInfo.requirements.afterStream.length; i += 1) {
          const req = questFormInfo.requirements.afterStream[i];
          delete questFormInfo.requirements.afterStream[i].value;
          if (req.icon === getDefaultIcon(req.type, req.subtype, questFormInformation, game)) {
            questFormInfo.requirements.afterStream[i].icon = false;
          }

          if (req.type === 'display-hashtags' || req.type === 'display-stream-time' || (req.type === 'display-text' && req.subtype === 'game-name')) {
            questFormInfo.requirements.afterStream[i].title = '';
          }
        }
      }
    }


    questFormInfo.prevGamesPlayed = prevGamesPlayed.sort();

    onSubmit(questFormInfo);
  }

  swapStep = (kind, index, direction) => {
    const swapIndex = (direction === 'up') ? index - 1 : index + 1;
    const { questForm, swapQuestStep } = this.props;
    let arr;
    if (kind === 'additional-questions') {
      arr = questForm.values.stepsPage1;
    }

    [arr[index], arr[swapIndex]] = [arr[swapIndex], arr[index]];
    swapQuestStep(kind, arr);
  }

  swapRequirement = (pointInQuest, index, direction) => {
    const swapIndex = (direction === 'up') ? index - 1 : index + 1;
    const { questForm, swapRequirements } = this.props;
    const arr = questForm.values.requirements[pointInQuest];
    [arr[index], arr[swapIndex]] = [arr[swapIndex], arr[index]];
    const newRequirements = questForm.values.requirements;
    newRequirements[pointInQuest] = arr;
    swapRequirements(newRequirements);
  }
  handleImageUpload = (imageType, params = {}) => {
    this.setState({
      activeModal: 1,
      image: imageType,
      ...params
    });
  }
  removeIcon = (pointInQuest, index) => {
    this.props.removeIcon({ pointInQuest, index });
  }

  // Steam Achievement相关方法
  // 打开成就选择窗口
  openAchievementModal = (pointInQuest, index, isModifying = false, modifyingAchievementId = null) => {
    this.setState({
      achievementModal: {
        isOpen: true,
        pointInQuest,
        index,
        isModifying,
        modifyingAchievementId
      }
    });
  };

  // 关闭成就选择窗口
  closeAchievementModal = () => {
    this.setState({
      achievementModal: {
        isOpen: false,
        pointInQuest: null,
        index: null,
        isModifying: false,
        modifyingAchievementId: null
      }
    });
  };

  // 从需求中移除成就
  removeAchievement = (achievementId, pointInQuest, index) => {
    const { questForm } = this.props;
    const currentAchievements = questForm?.values?.requirements?.[pointInQuest]?.[index]?.gameAchievements || [];
    const updatedAchievements = currentAchievements.filter(ach => ach.id !== achievementId);
    this.props.dispatch(change('questForm', `requirements.${pointInQuest}[${index}].gameAchievements`, updatedAchievements));
  };

  // 获取 Steam 游戏成就数据（从后端接口）
  getSteamGameAchievements = async (gameId, page = 1, limit = 50, loadMore = false) => {
    if (!gameId) {
      console.warn('gameId为空，无法获取成就');
      return { achievements: [], game: {}, pagination: {}, stats: {} };
    }

    // 防止重复调用
    if (this.state.steamAchievements.isLoading) {
      console.log('成就数据正在加载中，跳过重复请求');
      return { achievements: [], game: {}, pagination: {}, stats: {} };
    }

    // 如果已经有相同gameId的数据且不是强制刷新或加载更多，则跳过
    if (this.state.steamAchievements.game.id === gameId && 
        this.state.steamAchievements.data.length > 0 && !loadMore && page === 1) {
      console.log('成就数据已存在，直接返回');
      return {
        achievements: this.state.steamAchievements.data,
        game: this.state.steamAchievements.game,
        pagination: this.state.steamAchievements.pagination,
        stats: this.state.steamAchievements.stats
      };
    }

    // 设置加载状态
    this.setState(prevState => ({
      steamAchievements: {
        ...prevState.steamAchievements,
        isLoading: true,
        error: null
      }
    }));

    try {
      const { auth: { token } } = this.props;
      const response = await fetch(`/api/v1/admin/game/${gameId}/steam-achievements?page=${page}&limit=${limit}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`,
        },
      });
      
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      
      const result = await response.json();
      
      if (result.success && result.data) {
        console.log('获取Steam成就成功:', result.data);
        
        // 设置成功状态
        this.setState(prevState => ({
          steamAchievements: {
            ...prevState.steamAchievements,
            data: loadMore 
              ? [...prevState.steamAchievements.data, ...(result.data.achievements || [])]
              : result.data.achievements || [],
            game: result.data.game || {},
            pagination: result.data.pagination || {},
            stats: result.data.stats || {},
            isLoading: false,
            error: null
          }
        }));

        return {
          achievements: loadMore 
            ? [...this.state.steamAchievements.data, ...(result.data.achievements || [])]
            : result.data.achievements || [],
          game: result.data.game || {},
          pagination: result.data.pagination || {},
          stats: result.data.stats || {}
        };
      } else {
        console.error('获取Steam成就失败:', result);
        
        // 设置错误状态
        this.setState(prevState => ({
          steamAchievements: {
            ...prevState.steamAchievements,
            isLoading: false,
            error: result.message || 'Unknown error'
          }
        }));

        return { achievements: [], game: {}, pagination: {}, stats: {} };
      }
    } catch (error) {
      console.error('获取Steam成就失败:', error);
      
      // 设置错误状态
      this.setState(prevState => ({
        steamAchievements: {
          ...prevState.steamAchievements,
          isLoading: false,
          error: error.message
        }
      }));

      return { achievements: [], game: {}, pagination: {}, stats: {} };
    }
  };

  // 加载下一页Steam成就
  loadMoreSteamAchievements = async () => {
    const { game } = this.props;
    const { steamAchievements } = this.state;
    
    if (!steamAchievements.pagination?.page || !steamAchievements.pagination?.pages) {
      return;
    }
    
    const currentPage = steamAchievements.pagination.page;
    const totalPages = steamAchievements.pagination.pages;
    
    if (currentPage >= totalPages) {
      return; // 已经是最后一页
    }
    
    const nextPage = currentPage + 1;
    await this.getSteamGameAchievements(game?.id, nextPage, 50, true);
  };

  // 向需求中添加成就（优先使用缓存数据）
  addAchievementToRequirement = async (achievementId, pointInQuest, index) => {
    const { questForm, game } = this.props;
    const currentAchievements = questForm?.values?.requirements?.[pointInQuest]?.[index]?.gameAchievements || [];
    
    try {
      let achievements = [];
      
      // 优先使用已缓存的成就数据
      if (this.state.steamAchievements.data.length > 0 && 
          this.state.steamAchievements.game.id === game?.id) {
        achievements = this.state.steamAchievements.data;
      } else {
        // 如果没有缓存数据，获取新数据
        const result = await this.getSteamGameAchievements(game?.id);
        achievements = result.achievements || [];
      }
      
      const achievement = achievements.find(ach => ach.id === achievementId);
      
      if (achievement && !currentAchievements.find(ach => ach.id === achievementId)) {
        const updatedAchievements = [...currentAchievements, achievement];
        this.props.dispatch(change('questForm', `requirements.${pointInQuest}[${index}].gameAchievements`, updatedAchievements));
      }
    } catch (error) {
      console.error('添加成就到需求失败:', error);
    }
  };

  // 从窗口选择成就（优先使用缓存数据）
  selectAchievementFromModal = async (achievementId) => {
    const { achievementModal } = this.state;
    const { questForm, game } = this.props;
    const currentAchievements = questForm?.values?.requirements?.[achievementModal.pointInQuest]?.[achievementModal.index]?.gameAchievements || [];
    
    try {
      let achievements = [];
      
      // 优先使用已缓存的成就数据
      if (this.state.steamAchievements.data.length > 0 && 
          this.state.steamAchievements.game.id === game?.id) {
        achievements = this.state.steamAchievements.data;
      } else {
        // 如果没有缓存数据，获取新数据
        const result = await this.getSteamGameAchievements(game?.id);
        achievements = result.achievements || [];
      }
      
      const achievement = achievements.find(ach => ach.id === achievementId);
      
      if (achievement) {
        let updatedAchievements;
        
        if (achievementModal.isModifying && achievementModal.modifyingAchievementId) {
          // 替换现有成就
          updatedAchievements = currentAchievements.map(ach => 
            ach.id === achievementModal.modifyingAchievementId ? achievement : ach
          );
        } else {
          // 添加新成就（如果不存在）
          if (!currentAchievements.find(ach => ach.id === achievementId)) {
            updatedAchievements = [...currentAchievements, achievement];
          } else {
            updatedAchievements = currentAchievements;
          }
        }
        
        this.props.dispatch(change('questForm', `requirements.${achievementModal.pointInQuest}[${achievementModal.index}].gameAchievements`, updatedAchievements));
      }
    } catch (error) {
      console.error('从窗口选择成就失败:', error);
    }
    
    this.closeAchievementModal();
  };

  // 渲染Steam Achievement Modal
  renderAchievementModal = () => {
    const { achievementModal, steamAchievements } = this.state;
    const { game } = this.props;

    if (!achievementModal.isOpen) return null;

    return (
      <>
        <style>
          {`
            @keyframes spin {
              0% { transform: rotate(0deg); }
              100% { transform: rotate(360deg); }
            }
          `}
        </style>
        <div style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(0,0,0,0.5)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          zIndex: 1000
        }} onClick={this.closeAchievementModal}>
          <div style={{
            backgroundColor: 'white',
            borderRadius: '8px',
            maxWidth: '800px',
            width: '90%',
            maxHeight: '80%',
            overflow: 'hidden',
            display: 'flex',
            flexDirection: 'column'
          }} onClick={(e) => e.stopPropagation()}>
            <div style={{
              padding: '20px',
              borderBottom: '1px solid #eee',
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center'
            }}>
              <div>
                <h3 style={{ margin: '0 0 4px 0', fontSize: '18px', fontWeight: 'bold', color: '#1a202c' }}>
                  选择Steam成就
                  {steamAchievements.stats?.totalAchievements && (
                    <span style={{ fontSize: '14px', fontWeight: 'normal', color: '#666', marginLeft: '8px' }}>
                      (共 {steamAchievements.stats.totalAchievements} 个)
                    </span>
                  )}
                </h3>
                <p style={{ margin: 0, fontSize: '12px', color: '#666' }}>
                  点击成就即可添加到任务需求中
                </p>
              </div>
              <button 
                onClick={this.closeAchievementModal}
                style={{
                  background: 'none',
                  border: 'none',
                  fontSize: '24px',
                  cursor: 'pointer',
                  color: '#999',
                  padding: '4px',
                  borderRadius: '4px',
                  transition: 'all 0.2s'
                }}
                onMouseEnter={(e) => {
                  e.target.style.backgroundColor = '#f0f0f0';
                  e.target.style.color = '#666';
                }}
                onMouseLeave={(e) => {
                  e.target.style.backgroundColor = 'transparent';
                  e.target.style.color = '#999';
                }}
              >
                ×
              </button>
            </div>
            
            <div style={{ flex: 1, overflow: 'auto', padding: '20px' }}>
              {steamAchievements.isLoading && (
                <div style={{ 
                  textAlign: 'center', 
                  padding: '60px 20px',
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center'
                }}>
                  <div style={{
                    width: '40px',
                    height: '40px',
                    border: '3px solid #f3f3f3',
                    borderTop: '3px solid #3182ce',
                    borderRadius: '50%',
                    animation: 'spin 1s linear infinite',
                    marginBottom: '16px'
                  }}></div>
                  <div style={{ fontSize: '14px', color: '#666' }}>正在加载Steam成就...</div>
                </div>
              )}
              
              {steamAchievements.error && (
                <div style={{ 
                  textAlign: 'center', 
                  padding: '60px 20px',
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center'
                }}>
                  <div style={{
                    fontSize: '48px',
                    marginBottom: '16px',
                    color: '#e53e3e'
                  }}>⚠️</div>
                  <div style={{ 
                    fontSize: '16px',
                    fontWeight: 'bold',
                    color: '#e53e3e',
                    marginBottom: '8px'
                  }}>
                    加载失败
                  </div>
                  <div style={{ 
                    fontSize: '14px',
                    color: '#666',
                    marginBottom: '16px'
                  }}>
                    {steamAchievements.error}
                  </div>
                  <button
                    onClick={() => {
                      // 重置数据并重新获取
                      this.setState(prevState => ({
                        steamAchievements: {
                          ...prevState.steamAchievements,
                          data: [],
                          pagination: {},
                          stats: {},
                          error: null
                        }
                      }));
                      this.getSteamGameAchievements(game?.id);
                    }}
                    style={{
                      backgroundColor: '#3182ce',
                      color: 'white',
                      border: 'none',
                      padding: '8px 16px',
                      borderRadius: '4px',
                      cursor: 'pointer',
                      fontSize: '12px'
                    }}
                  >
                    重试
                  </button>
                </div>
              )}
              
              {!steamAchievements.isLoading && !steamAchievements.error && steamAchievements.data.length === 0 && (
                <div style={{ 
                  textAlign: 'center', 
                  padding: '60px 20px',
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center'
                }}>
                  <div style={{
                    fontSize: '48px',
                    marginBottom: '16px',
                    color: '#a0aec0'
                  }}>🏆</div>
                  <div style={{ 
                    fontSize: '16px',
                    fontWeight: 'bold',
                    color: '#4a5568',
                    marginBottom: '8px'
                  }}>
                    暂无可用成就
                  </div>
                  <div style={{ 
                    fontSize: '14px',
                    color: '#666'
                  }}>
                    该游戏尚未配置Steam成就数据
                  </div>
                </div>
              )}
              
              {!steamAchievements.isLoading && !steamAchievements.error && steamAchievements.data.map(achievement => (
                <div 
                  key={achievement.id} 
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    padding: '16px',
                    margin: '8px 0',
                    backgroundColor: achievement.hidden ? '#fff5f5' : '#f8f9fa',
                    border: `1px solid ${achievement.hidden ? '#fed7d7' : '#e1e5e9'}`,
                    borderRadius: '8px',
                    cursor: 'pointer',
                    transition: 'all 0.2s ease',
                    position: 'relative'
                  }}
                  onClick={() => this.selectAchievementFromModal(achievement.id)}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.backgroundColor = achievement.hidden ? '#fed7d7' : '#e9ecef';
                    e.currentTarget.style.transform = 'translateY(-1px)';
                    e.currentTarget.style.boxShadow = '0 4px 12px rgba(0,0,0,0.1)';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.backgroundColor = achievement.hidden ? '#fff5f5' : '#f8f9fa';
                    e.currentTarget.style.transform = 'translateY(0)';
                    e.currentTarget.style.boxShadow = 'none';
                  }}
                >
                  <div style={{
                    width: '64px',
                    height: '64px',
                    marginRight: '16px',
                    borderRadius: '8px',
                    overflow: 'hidden',
                    backgroundColor: '#f0f0f0',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    position: 'relative',
                    border: '2px solid rgba(0,0,0,0.1)'
                  }}>
                    <img
                      src={achievement.icon}
                      alt={achievement.displayName}
                      style={{
                        width: '100%',
                        height: '100%',
                        objectFit: 'contain',
                        opacity: achievement.hidden ? 0.7 : 1
                      }}
                      onError={(e) => {
                        e.target.style.display = 'none';
                        const placeholder = document.createElement('div');
                        placeholder.innerHTML = '🏆';
                        placeholder.style.cssText = 'width:100%;height:100%;display:flex;align-items:center;justify-content:center;font-size:24px;color:#999;';
                        e.target.parentElement.appendChild(placeholder);
                      }}
                    />
                    {achievement.hidden && (
                      <div style={{
                        position: 'absolute',
                        top: '-6px',
                        right: '-6px',
                        background: 'linear-gradient(45deg, #e53e3e, #c53030)',
                        color: 'white',
                        borderRadius: '50%',
                        width: '20px',
                        height: '20px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        fontSize: '10px',
                        fontWeight: 'bold',
                        border: '2px solid white',
                        boxShadow: '0 2px 4px rgba(0,0,0,0.2)'
                      }}>
                        ?
                      </div>
                    )}
                  </div>
                  
                  <div style={{ flex: 1 }}>
                    <div style={{
                      fontWeight: 'bold',
                      fontSize: '16px',
                      color: '#1a202c',
                      marginBottom: '4px'
                    }}>
                      {achievement.displayName}
                    </div>
                    <div style={{
                      fontSize: '14px',
                      color: '#4a5568',
                      marginBottom: '8px',
                      lineHeight: '1.4'
                    }}>
                      {achievement.description}
                    </div>
                    <div style={{
                      fontSize: '12px',
                      color: '#2b6cb0',
                      fontWeight: '600'
                    }}>
                      全球完成率: {achievement.globalPercent > 0 ? `${achievement.globalPercent.toFixed(1)}%` : '< 0.1%'}
                    </div>
                  </div>
                  
                  <div style={{
                    padding: '8px 12px',
                    backgroundColor: '#3182ce',
                    color: 'white',
                    borderRadius: '6px',
                    fontSize: '12px',
                    fontWeight: 'bold',
                    opacity: 0.8,
                    transition: 'opacity 0.2s'
                  }}>
                    选择
                  </div>
                </div>
              ))}
              
              {/* 分页信息和分页按钮 */}
              {!steamAchievements.isLoading && !steamAchievements.error && steamAchievements.data.length > 0 && (
                <div style={{
                  marginTop: '20px',
                  padding: '16px',
                  backgroundColor: '#f7fafc',
                  borderRadius: '8px'
                }}>
                  <div style={{
                    fontSize: '14px',
                    color: '#4a5568',
                    marginBottom: '16px',
                    textAlign: 'center'
                  }}>
                    共 {steamAchievements.pagination?.total || steamAchievements.data.length} 个成就
                    {steamAchievements.pagination?.pages > 1 && (
                      <span style={{ marginLeft: '8px' }}>
                        · 第 {steamAchievements.pagination.page || 1} 页，共 {steamAchievements.pagination.pages} 页
                      </span>
                    )}
                  </div>
                  
                  {steamAchievements.pagination?.pages > 1 && (
                    <div style={{
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                      gap: '12px'
                    }}>
                      <button
                        onClick={() => {
                          const prevPage = (steamAchievements.pagination.page || 1) - 1;
                          if (prevPage >= 1) {
                            // 重置数据并加载指定页面
                            this.setState(prevState => ({
                              steamAchievements: {
                                ...prevState.steamAchievements,
                                data: []
                              }
                            }));
                            this.getSteamGameAchievements(game?.id, prevPage, 50, false);
                          }
                        }}
                        disabled={steamAchievements.isLoading || (steamAchievements.pagination.page || 1) <= 1}
                        style={{
                          backgroundColor: (steamAchievements.pagination.page || 1) <= 1 ? '#e2e8f0' : '#3182ce',
                          color: (steamAchievements.pagination.page || 1) <= 1 ? '#a0aec0' : 'white',
                          border: 'none',
                          padding: '8px 16px',
                          borderRadius: '6px',
                          cursor: (steamAchievements.pagination.page || 1) <= 1 ? 'not-allowed' : 'pointer',
                          fontSize: '14px',
                          fontWeight: 'bold',
                          transition: 'all 0.2s'
                        }}
                        onMouseEnter={(e) => {
                          if (!steamAchievements.isLoading && (steamAchievements.pagination.page || 1) > 1) {
                            e.target.style.backgroundColor = '#2c5aa0';
                          }
                        }}
                        onMouseLeave={(e) => {
                          if (!steamAchievements.isLoading && (steamAchievements.pagination.page || 1) > 1) {
                            e.target.style.backgroundColor = '#3182ce';
                          }
                        }}
                      >
                        上一页
                      </button>
                      
                      <span style={{
                        fontSize: '14px',
                        color: '#2d3748',
                        fontWeight: 'bold',
                        minWidth: '100px',
                        textAlign: 'center'
                      }}>
                        {steamAchievements.pagination.page || 1} / {steamAchievements.pagination.pages || 1}
                      </span>
                      
                      <button
                        onClick={() => {
                          const nextPage = (steamAchievements.pagination.page || 1) + 1;
                          if (nextPage <= steamAchievements.pagination.pages) {
                            // 重置数据并加载指定页面
                            this.setState(prevState => ({
                              steamAchievements: {
                                ...prevState.steamAchievements,
                                data: []
                              }
                            }));
                            this.getSteamGameAchievements(game?.id, nextPage, 50, false);
                          }
                        }}
                        disabled={steamAchievements.isLoading || (steamAchievements.pagination.page || 1) >= (steamAchievements.pagination.pages || 1)}
                        style={{
                          backgroundColor: (steamAchievements.pagination.page || 1) >= (steamAchievements.pagination.pages || 1) ? '#e2e8f0' : '#3182ce',
                          color: (steamAchievements.pagination.page || 1) >= (steamAchievements.pagination.pages || 1) ? '#a0aec0' : 'white',
                          border: 'none',
                          padding: '8px 16px',
                          borderRadius: '6px',
                          cursor: (steamAchievements.pagination.page || 1) >= (steamAchievements.pagination.pages || 1) ? 'not-allowed' : 'pointer',
                          fontSize: '14px',
                          fontWeight: 'bold',
                          transition: 'all 0.2s'
                        }}
                        onMouseEnter={(e) => {
                          if (!steamAchievements.isLoading && (steamAchievements.pagination.page || 1) < (steamAchievements.pagination.pages || 1)) {
                            e.target.style.backgroundColor = '#2c5aa0';
                          }
                        }}
                        onMouseLeave={(e) => {
                          if (!steamAchievements.isLoading && (steamAchievements.pagination.page || 1) < (steamAchievements.pagination.pages || 1)) {
                            e.target.style.backgroundColor = '#3182ce';
                          }
                        }}
                      >
                        下一页
                      </button>
                    </div>
                  )}
                </div>
              )}
            </div>
          </div>
        </div>
      </>
    );
  };

  uploadToS3 = (file, preSignedUrl) => {
    const { image } = this.state;
    if ((image === 'banner' || image === 'regular' || image === 'overlay') && file.size > 500000) {
      if (file.size > 500000) {
        simpleNotification({
          level: 'warning',
          title: 'Warning',
          message: 'Image has a limit of 500kb.',
        });
        this.setState({
          activeModal: 1,
        });
        return;
      }
    }
    this.setState({ activeModal: 2 });
    const xhr = new XMLHttpRequest();
    xhr.open('PUT', preSignedUrl);
    xhr.setRequestHeader('Content-Type', file.type);
    xhr.addEventListener('load', this.handleLoad);
    xhr.send(file);
  }

  getTabClasses = (tab) => {
    const { questForm } = this.props;
    if (!questForm) return '';

    const { syncErrors, submitFailed } = questForm;
    if (!syncErrors || !submitFailed) return '';

    const errorClass = 'fa fa-times-circle red';

    if (tab === 'details') {
      if (
        syncErrors.type
        || syncErrors.title
        || syncErrors.status
        || syncErrors.isPrivate
        || syncErrors.openSpots
        || syncErrors.startDateTime
        || syncErrors.endDateTime
        || syncErrors.openRegistrationDate
        || syncErrors.closeRegistrationDate
        || syncErrors.expectedPayoutDate
        || syncErrors.group
        || syncErrors.minimumAverageViewers
        || syncErrors.minimumAveragePlayCount
        || syncErrors.requiredBanner
        || syncErrors.bannerLink
      ) {
        return errorClass;
      }
    }

    if (tab === 'parameters') {
      if (
        syncErrors.isReferral
        || syncErrors.referralBonus
        || syncErrors.salesForBonus
        || syncErrors.bonusValue
        || syncErrors.referralBonusType
        || syncErrors.referralBonusTimes
        || syncErrors.comingSoon
        || syncErrors.keyRequired
        || syncErrors.userCanleave
        || syncErrors.plus18
        || syncErrors.tags
        || syncErrors.paymentMade
        || syncErrors.hideFrontpage
        || syncErrors.hideOpenSpots
        || syncErrors.requirePreapproval
        || syncErrors.twitterAccountRequired
        || syncErrors.twitchAccountRequired
        || syncErrors.youtubeAccountRequired
        || syncErrors.joinButtonText
        || syncErrors.linkout
        || syncErrors.referralPaymentType
        || syncErrors.commissionAmount
        || syncErrors.commissionPercentage
        || syncErrors.minimumAverageViewersReferral
        || syncErrors.requiredStreamTimeMinutes
        || syncErrors.questTags
        || syncErrors.dailyEarning
        || syncErrors.paymentAmount
        || syncErrors.memberTiers
        || syncErrors.viewerTiers
        || syncErrors.splitTiers
        || syncErrors.rankTiers
        || syncErrors.whitelist
        || syncErrors.platforms
        || syncErrors.countries
        || syncErrors.languages
        || syncErrors.miniFollowers
      ) {
        console.log('syncErrors', syncErrors);
        return errorClass;
      }
    }

    if (tab === 'user-info') {
      if (
        syncErrors.slug
        || syncErrors.stepsPage1
        || syncErrors.requirements
      ) {
        return errorClass;
      }
    }

    if (tab === 'faq') {
      if (
        syncErrors.faqs
      ) {
        return errorClass;
      }
    }

    if (tab === 'questDescription') {
      if (
        syncErrors.questDescriptions
      ) {
        return errorClass;
      }
    }

    // Sub-tabs
    if ((
      tab === 'viewerTiers'
      || tab === 'memberTiers'
      || tab === 'whitelist'
      || tab === 'slug'
      || tab === 'stepsPage1'
      || tab === 'requirements'
      || tab === 'splitTiers'
      || tab === 'rankTiers'
    ) && syncErrors[tab]) {
      return errorClass;
    }
    return '';
  }
  countriesOptions = () => getCountryOptions();
  languagesOptions = () => getLanguageOptions();
  platformOptions = () => {
    const { game: { platforms = [] } } = this.props;
    return getPlatformOptions(platforms);
  }

  handleLoad = (event) => {
    const { preSignedUrl: { data: signedUrl }, updateCCQuestForm } = this.props;
    const { image, pointInQuestIcon, indexIcon } = this.state;

    if (event.target.status !== 200) {
      this.setState({
        activeModal: 0,
      });
      simpleNotification({
        level: 'error',
        title: 'Error',
        message: 'Error uploading the image, try again please.',
      });
      return;
    }

    simpleNotification({
      level: 'success',
      title: 'Success',
      message: 'The image was uploaded succesfully!',
    });

    if (image === 'banner') {
      updateCCQuestForm({ requiredBanner: signedUrl.url });
    } else if (image === 'regular') {
      updateCCQuestForm({ regularImage: signedUrl.url });
    } else if (image === 'overlay') {
      updateCCQuestForm({ overlayImage: signedUrl.url });
    } else if (image === 'icon') {
      updateCCQuestForm({ icon: signedUrl.url, pointInQuest: pointInQuestIcon, index: indexIcon });
    }

    this.setState({ activeModal: 0 });
  }
  addRequirement = (fields, req) => {
    const { questForm, game, quest = {} } = this.props;
    // Get preload requirement stuff
    // 确保传递有效的 quest 对象
    const safeQuest = quest || {};
    const preloadedReq = preloadRequirement(req.type, req.subtype, questForm.values, game, safeQuest);

    const newRequirement = {
      type: req.type,
      subtype: req.subtype,
      title: preloadedReq.title,
      description: preloadedReq.description || '',
      label: preloadedReq.label,
      placeholder: preloadedReq.placeholder,
      tooltip: preloadedReq.tooltip,
      approvalRequired: preloadedReq.approvalRequired,
      id: uuidv4().replace(/-/g, ''),
      icon: preloadedReq.icon,
      customIcon: false,
      value: req.value,
    };

    // 为 Steam Achievement 类型添加默认字段
    if (req.type === 'submit-steam-achievement') {
      newRequirement.achievementMustBeCompleted = false;
    }

    fields.push(newRequirement);

    return fields;
  }
  /* START REQUIREMENTS */
  renderRequirements = ({
    fields,
    meta,
    pointInQuest,
  }) => {
    const { game, questForm } = this.props;
    return (
      <Requirements
        fields={fields}
        meta={meta}
        pointInQuest={pointInQuest}
        questForm={questForm}
        game={game}
        onAddRequirement={(fields, req) => this.addRequirement(fields, req)}
        onImageUpload={this.handleImageUpload}
        onSwapRequirement={this.swapRequirement}
        onRichTextUpdate={this.handleRichTextUpdates}
        onOpenAchievementModal={this.openAchievementModal}
        onRemoveAchievement={this.removeAchievement}
      />
    );
  };

  /* END REQUIREMENTS */

  handleRichTextUpdates = (content, formValueString) => {
    console.log('handleRichTextUpdates 收到内容:', content);
    console.log('handleRichTextUpdates 收到表单值字符串:', formValueString);
    this.props.dispatch(change('questForm', formValueString, content));
  }

  handleTypeChange = (value, form) => {
    const { questForm } = this.props;
    console.log('handleTypeChange', value, form);
    console.log('handleTypeChange questForm', questForm);
    if (value === 'tiered-one-time' || value === 'timed') {
      // form.change('frequency', 'one-time');
    } else if (value === 'tiered-multi-days' || value === 'paid bounty' || value === 'tiered-auto' || value === 'secondary-creation') {
      // form.change('frequency', 'daily');
    }


    // 清空所有 tiers 相关数据 - 无论切换到什么类型都清空
    // 1. 清空 memberTiers
    if (questForm?.values?.memberTiers?.length > 0) {
      this.props.change('memberTiers', []);
    }

    // 2. 清空 viewerTiers
    if (questForm?.values?.viewerTiers?.length > 0) {
      this.props.change('viewerTiers', []);
    }

    // 3. 清空 rankTiers
    if (questForm?.values?.rankTiers?.length > 0) {
      this.props.change('rankTiers', []);
    }

    // 4. 清空 splitTiers
    if (questForm?.values?.splitTiers?.length > 0) {
      this.props.change('splitTiers', []);
    }
    
    // 5. 清空 Steam Achievement 相关数据 - 当切换到不支持的类型时
    if (value === 'tiered-auto' || value === 'secondary-creation') {
      // 清空所有 requirements 中的 submit-steam-achievement 类型的 requirement
      const requirements = questForm?.values?.requirements;
      if (requirements) {
        const pointInQuestKeys = ['beforeStream', 'duringStream', 'afterStream'];
        
        pointInQuestKeys.forEach(pointInQuest => {
          if (requirements[pointInQuest] && Array.isArray(requirements[pointInQuest])) {
            // 过滤掉所有 submit-steam-achievement 类型的 requirement
            const filteredRequirements = requirements[pointInQuest].filter(req => 
              req.type !== 'submit-steam-achievement'
            );
            
            // 如果有 submit-steam-achievement 被过滤掉了，更新 requirements
            if (filteredRequirements.length !== requirements[pointInQuest].length) {
              console.log(`从 ${pointInQuest} 中删除 submit-steam-achievement requirements`);
              this.props.change(`requirements.${pointInQuest}`, filteredRequirements);
            }
          }
        });
      }
    }
    
    if (value === 'tiered-auto' || value === 'secondary-creation') {
      // form.change('twitchAccountRequired', true);
      // form.change('requirePreapproval', false);
    }

    if (value === 'secondary-creation' || value === 'youtube-video') {
      this.props.change('youtubeAccountRequired', true);
      this.props.change('twitchAccountRequired', false);
    } else {
      this.props.change('youtubeAccountRequired', false);
    }

    if (value === 'tiered-auto') {
      // form.change('requirePreapproval', true);
    }
  }

  handleStartChange = (value) => {
    const { isNewTypeQuest } = this.getQuestTypeFlags();
    console.log('handleStartChange 收到值:', value);

    if (isNewTypeQuest) {
      // 不需要进行时区转换，因为在 CustomDateTimePicker 组件中已经处理过
      this.props.change('openRegistrationDate', value);
    }
  }

  // 当结束时间改变时，将 closeRegistrationDate 更新为相同的值，并将 expectedPayoutDate 设置为结束时间加24小时
  handleEndChange = (value) => {
    const { isNewTypeQuest, secondaryCreationQuest } = this.getQuestTypeFlags();
    console.log('handleEndChange 收到值:', value);

    if (isNewTypeQuest) {
      // 同步设置 Close Registration Date 为 endDateTime
      this.props.change('closeRegistrationDate', value);

      // 计算预计支付日期为 endDateTime 加24小时
      // 使用 moment 处理 ISO 字符串，确保在 UTC 时区进行运算

      let expectedPayout = moment.utc(value)
        .add(24, 'hours')
        .toISOString();
      if (secondaryCreationQuest) {
        expectedPayout = moment.utc(value)
          .add(7 * 24, 'hours')
          .toISOString();
      }
      console.log('计算的预计支付日期:', expectedPayout);
      this.props.change('expectedPayoutDate', expectedPayout);
    }
  };
  renderRankMode = ({ fields, meta }) => (
    <RankMode
      fields={fields}
      meta={meta}
      questForm={this.props.questForm}
      quest={this.props.quest}
      autoStreamingQuest={this.getQuestTypeFlags().autoStreamingQuest}
      secondaryCreationQuest={this.getQuestTypeFlags().secondaryCreationQuest}
    />
  );
  renderSplitMode = ({ fields, meta }) => (
    <SplitMode
      fields={fields}
      meta={meta}
      questForm={this.props.questForm}
      quest={this.props.quest}
      autoStreamingQuest={this.getQuestTypeFlags().autoStreamingQuest}
      secondaryCreationQuest={this.getQuestTypeFlags().secondaryCreationQuest}
    />
  );
  renderWhiteList = ({ fields, meta }) => (
    <WhiteList
      fields={fields}
      meta={meta}
      questForm={this.props.questForm}
      parametersSubTab={this.state.parametersSubTab}
      onRemove={(fields, index) => {
        if (window.confirm(`Are you sure about removing ${this.props.questForm.values.whitelist[index].identity} from this whitelist?`)) {
          fields.remove(index);
        }
      }}
    />
  );
  renderViewerTiers = ({ fields, meta }) => (
    <ViewerTiers
      fields={fields}
      meta={meta}
      questForm={this.props.questForm}
      parametersSubTab={this.state.parametersSubTab}
      streamingQuest={this.getQuestTypeFlags().streamingQuest}
    />
  );
  renderMemberTiers = ({ fields, meta }) => (
    <MemberTiers
      fields={fields}
      meta={meta}
      questForm={this.props.questForm}
      parametersSubTab={this.state.parametersSubTab}
    />
  );
  renderRules = ({ fields, meta, ...custom }) => {
    const { configRules, questForm } = this.props;
    return (
      <Rules
        fields={fields}
        meta={meta}
        configRules={configRules}
        questForm={questForm}
        stepIndex={custom.stepIndex}
      />
    );
  };
  titleSlug = (e, title) => {
    const {
      questForm: { fields: { slug } },
      titleSlugApply,
    } = this.props;

    if (!slug || !slug.visited) {
      titleSlugApply(friendlyURICharacters(replaceSpaces(title)));
    }
  }



  renderTooltip = (label, content) => (
    <label>
      {label}
      <span className="tooltip">
        <i className="tooltip-icon fa fa-info-circle" />
        <div className="tooltip-content">
          {content}
        </div>
      </span>
    </label>
  );

  changeModalState = (value) => {
    this.setState({ activeModal: value });
  }

  onDragEnter = () => {
    this.setState({ dropzoneActive: true });
  }

  onDragLeave = () => {
    this.setState({ dropzoneActive: false });
  }
  render = () => {
    const {
      auth: { token },
      // game: { id: gameId = '' },
      handleSubmit,
      pathname,
      preSignedUrl: { isLoading },
      quest = {},
      questForm = {},
    } = this.props;

    const pathSegs = pathname.split('/');
    const action = pathSegs[pathSegs.length - 1];

    const {
      activeModal,
      disableClick,
      dropzoneActive,
      parametersSubTab,
      parametersAwardMode,
      prevGamesPlayed,
      subTab,
      tab
    } = this.state;

    // Check for "Send failure email" functionality
    const emailFailureSentDate = (questForm.values && questForm.values.emailFailure && questForm.values.emailFailure.sentDate) ? moment(questForm.values.emailFailure.sentDate).format('MMMM DD, YYYY - hh:mm a') : false;

    // Check for "Send reminder email" functionality
    const emailReminderSentDate = (questForm.values && questForm.values.emailReminder && questForm.values.emailReminder.sentDate) ? moment(questForm.values.emailReminder.sentDate).format('MMMM DD, YYYY - hh:mm a') : false;

    let questMeetsReminderMin = true;
    if (questForm.values && questForm.values.startDateTime && questForm.values.endDateTime && questForm.values.openRegistrationDate && questForm.values.closeRegistrationDate && questForm.values.expectedPayoutDate) {
      questMeetsReminderMin = !(getQuestDurationHours(questForm.values) <= 48);
      // 移除这些格式转换，因为它们在CustomDateTimePicker组件内部已经正确处理了
      // 这些转换会导致时区问题，因为它们转换为字符串并丢失时区信息
      // questForm.values.startDateTime = moment.utc(questForm.values.startDateTime).local().format('YYYY-MM-DD HH:mm')
      // questForm.values.endDateTime = moment.utc(questForm.values.endDateTime).local().format('YYYY-MM-DD HH:mm')
      // questForm.values.openRegistrationDate = moment.utc(questForm.values.openRegistrationDate).local().format('YYYY-MM-DD HH:mm')
      // questForm.values.closeRegistrationDate = moment.utc(questForm.values.closeRegistrationDate).local().format('YYYY-MM-DD HH:mm')
      // questForm.values.expectedPayoutDate = moment.utc(questForm.values.expectedPayoutDate).local().format('YYYY-MM-DD HH:mm')
      // console.log('questForm.values.startDateTime', questForm.values.startDateTime)
      // console.log('quest.endDateTime', quest.endDateTime)
    }

    const detailsTabClasses = this.getTabClasses('details');
    const parametersTabClasses = this.getTabClasses('parameters');
    const userInfoTabClasses = this.getTabClasses('user-info');
    const faqsTabClasses = this.getTabClasses('faqs');
    const splitTiersTabClasses = this.getTabClasses('splitTiers');
    const rankTiersTabClasses = this.getTabClasses('rankTiers');
    const viewerTiersTabClasses = this.getTabClasses('viewerTiers');
    const memberTiersTabClasses = this.getTabClasses('memberTiers');
    const whitelistTabClasses = this.getTabClasses('whitelist');
    const slugTabClasses = this.getTabClasses('slug');
    const stepsPage1TabClasses = this.getTabClasses('stepsPage1');
    const requirementsTabClasses = this.getTabClasses('requirements');


    // 使用封装好的方法，获得任务类型 flags
    const {
      streamingQuest,
      secondaryCreationQuest,
      isNewTypeQuest,
      isStreamOrNewTypeQuest,
    } = this.getQuestTypeFlags();
    
    const isYoutubeVideoQuest = questForm?.values?.type === 'youtube-video';


    return (
      <div>
        {/* Global Tabs */}
        <div className="Global__tabs">
          <div className={classNames('Global__tab', { active: tab === 'details' })} onClick={() => this.setState({ tab: 'details' })} aria-hidden>Details<i className={detailsTabClasses} /></div>
          <div className={classNames('Global__tab', { active: tab === 'parameters' })} onClick={() => this.setState({ tab: 'parameters' })} aria-hidden>Parameters<i className={parametersTabClasses} /></div>
          <div className={classNames('Global__tab', { active: tab === 'user-info' })} onClick={() => this.setState({ tab: 'user-info' })} style={{ width: '180px' }} aria-hidden>User Information<i className={userInfoTabClasses} /></div>
          <div className={classNames('Global__tab', { active: tab === 'faq' })} onClick={() => this.setState({ tab: 'faq' })} aria-hidden>FAQ<i className={faqsTabClasses} /></div>
          <div className={classNames('Global__tab', { active: tab === 'logs' })} onClick={() => this.setState({ tab: 'logs' })} aria-hidden>Logs</div>
        </div>
        <form className="form-container quests-edit" autoComplete="off" onSubmit={handleSubmit(this.submit.bind(this))}>
          <Details
            handleTypeChange={this.handleTypeChange}
            titleSlug={this.titleSlug}
            handleStartChange={this.handleStartChange}
            handleEndChange={this.handleEndChange}
            questForm={questForm}
            streamingQuest={streamingQuest}
            isNewTypeQuest={isNewTypeQuest}
            campaigns={this.props.campaigns}
            renderTooltip={this.renderTooltip}
            handleImageUpload={this.handleImageUpload}
            tab={tab}
          />
          <div className="info-tab-wrap" style={(tab === 'parameters') ? { display: 'block' } : { display: 'none' }}>

            <div style={{ display: 'none' }}>
              <Field
                name="comingSoon"
                id="comingSoon"
                type="checkbox"
                placeholder="Select Value"
                customLabel="Coming Soon"
                component={CustomInputCheckbox}
              />
            </div>

            <Field
              name="platforms"
              id="platforms"
              component={ArrayDropDown}
              styles={arrayDropDownColors}
              customLabel={<label>Platforms</label>}
              optionsToRender={this.platformOptions()}
            />
            <Field
              type="text"
              name="countries"
              id="countries"
              placeholder="Countries"
              customLabel="Countries"
              component={ArrayDropDown}
              styles={arrayDropDownColors}
              isMulti
              isClearable={false}
              optionsToRender={this.countriesOptions()}
            />
            <Field
              type="text"
              name="languages"
              id="languages"
              placeholder="Languages"
              customLabel="Languages"
              component={ArrayDropDown}
              styles={arrayDropDownColors}
              isMulti
              isClearable={false}
              optionsToRender={this.languagesOptions()}
            />
            <RequiredGames
              token={token}
              values={prevGamesPlayed}
              onChange={arr => this.setState({ prevGamesPlayed: arr })}
            />
            <Field
              name="keyRequired"
              id="keyRequired"
              type="checkbox"
              placeholder="Select Value"
              customLabel="Is Key Required?"
              component={CustomInputCheckbox}
            />
            {
              questForm?.values?.keyRequired && (
                <Field
                  name="allowKeyRedistribution"
                  id="allowKeyRedistribution"
                  type="checkbox"
                  placeholder="Select Value"
                  customLabel="Send an additional key even if the user already owns one for this game?"
                  tooltip="When on, approved users get a new key from the pool even if they already own one for this game (e.g. from a previous quest). Each user still receives only one key per quest."
                  component={CustomInputCheckbox}
                />
              )
            }
            <Field
              name="userCanleave"
              id="userCanLeave"
              type="checkbox"
              placeholder="Select Value"
              customLabel="User Can Leave?"
              component={CustomInputCheckbox}
            />
            <Field
              name="plus18"
              id="plus18"
              type="checkbox"
              placeholder="Select Value"
              customLabel="User must be 18+ to participate"
              component={CustomInputCheckbox}
            />
            {
              !isNewTypeQuest && !isYoutubeVideoQuest && (
                <>
                  <Field
                    name="paymentMade"
                    id="paymentMade"
                    type="checkbox"
                    placeholder="Select Value"
                    customLabel="Payment Made"
                    component={CustomInputCheckbox}
                  />
                  <Field
                    name="hideOpenSpots"
                    id="hideOpenSpots"
                    type="checkbox"
                    defaultChecked
                    placeholder="Select Value"
                    customLabel="Hide Open Spots"
                    component={CustomInputCheckbox}
                  />
                  <Field
                    name="requirePreapproval"
                    id="requirePreapproval"
                    type="checkbox"
                    placeholder="Select Value"
                    customLabel="Require Preapproval"
                    component={CustomInputCheckbox}
                  />
                  <Field
                    name="twitchAccountRequired"
                    id="twitchAccountRequired"
                    type="checkbox"
                    placeholder="Select Value"
                    customLabel="Require Connected Twitch Account"
                    component={CustomInputCheckbox}
                  />
                </>
              )
            }
            {
              isYoutubeVideoQuest && (
                  <Field
                    name="youtubeAccountRequired"
                    id="youtubeAccountRequired"
                    type="checkbox"
                    placeholder="Select Value"
                    customLabel="Require Connected YouTube Account"
                    component={CustomInputCheckbox}
                  />
              )
            }
            <Field
              name="twitterAccountRequired"
              id="twitterAccountRequired"
              type="checkbox"
              placeholder="Select Value"
              customLabel="Require Connected X, formerly known as Twitter, Account"
              component={CustomInputCheckbox}
            />
            {!isNewTypeQuest && streamingQuest &&
              <React.Fragment>
                <div className="input-container stream-time-wrap">
                  <label><b>Required Stream Time</b></label>
                  <div className="stream-time-inner-wrap">
                    <label>
                      <Field
                        type="text"
                        name="requiredStreamTimeMinutes"
                        id="requiredStreamTimeMinutes"
                        component={CustomInput}
                        placeholder="00"
                        onlyNumbers="true"
                      />
                    </label>
                    <span className="stream-label">
                      minutes
                      <span className="tooltip" style={{ display: (questForm.values && questForm.values.type === 'tiered-multi-days') ? 'inline-block' : 'none' }}>
                        <i className="tooltip-icon fa fa-info-circle" />
                        <div className="tooltip-content">
                          Indicates how much time they must stream every day for the multi-day quest.
                        </div>
                      </span>
                    </span>
                  </div>
                </div>
              </React.Fragment>
            }
            {!isStreamOrNewTypeQuest &&
              <>
                <Field
                  name="questTags"
                  id="questTags"
                  type="text"
                  placeholder="Select Value"
                  customLabel={this.renderTooltip(
                    'Quest Tags',
                    'Please use only A-Z, a-z, _, and 0-9 for the tags. Tags can\'t be only numbers.'
                  )}
                  component={CustomTagField}
                />

                <Field
                  name="trackingTags"
                  id="trackingTags"
                  type="text"
                  tracking
                  placeholder="Select Value"
                  customLabel={this.renderTooltip(
                    'Tracking Quest Tags',
                    'Checked against stream title. Be sure to use UNIQUE, quest specific tags to ensure we don\'t over track. Have streamers remove tags on completion'
                  )}
                  component={CustomTagField}
                />
              </>
            }
            {
              isNewTypeQuest ? (
                <TiersTaskMode
                  rankTiersTabClasses={rankTiersTabClasses}
                  questType={questForm.values?.type}
                  setSubTab={index => this.setState({ parametersAwardMode: index })}
                  streamingQuest={streamingQuest}
                  autoStreamingQuest={this.getQuestTypeFlags().autoStreamingQuest}
                  secondaryCreationQuest={this.getQuestTypeFlags().secondaryCreationQuest}
                  subTab={parametersAwardMode}
                  splitTiers={
                    () => <FieldArray
                      name="splitTiers"
                      component={this.renderSplitMode}
                    />
                  }
                  rankTiers={
                    () => <FieldArray
                      name="rankTiers"
                      component={this.renderRankMode}
                    />
                  }
                  splitTiersTabClasses={splitTiersTabClasses}
                  followers={() => <Field name="miniFollowers" component={Followers} />}
                />
              ) : (
                <TiersWhitelist
                  questType={questForm.values?.type}
                  setSubTab={index => this.setState({ parametersSubTab: index })}
                  streamingQuest={streamingQuest}
                  isYoutubeVideoQuest={isYoutubeVideoQuest}
                  subTab={parametersSubTab}
                  memberTiers={() =>
                    <FieldArray
                      name="memberTiers"
                      component={this.renderMemberTiers}
                    />}
                  memberTiersTabClasses={memberTiersTabClasses}
                  viewerTiers={() =>
                    <FieldArray
                      name="viewerTiers"
                      component={this.renderViewerTiers}
                    />}
                  viewerTiersTabClasses={viewerTiersTabClasses}
                  whitelist={() =>
                    <FieldArray
                      name="whitelist"
                      component={this.renderWhiteList}
                    />}
                  whitelistTabClasses={whitelistTabClasses}
                />
              )
            }
          </div>
          <div className="info-tab-wrap" style={(tab === 'user-info') ? { display: 'block' } : { display: 'none' }}>
            <div className="Global__subTabs">
              <div className={classNames('Global__subTab', { active: subTab === 'landing' })} onClick={() => this.setState({ subTab: 'landing' })} aria-hidden>
                Landing<i className={slugTabClasses} />
              </div>
              <div className={classNames('Global__subTab', { active: subTab === 'emails' })} onClick={() => this.setState({ subTab: 'emails' })} aria-hidden>
                Emails
              </div>
              <div className={classNames('Global__subTab', { active: subTab === 'additional-questions' })} onClick={() => this.setState({ subTab: 'additional-questions' })} aria-hidden>
                Additional Questions<i className={stepsPage1TabClasses} />
              </div>
              <div className={classNames('Global__subTab', { active: subTab === 'requirements' })} onClick={() => this.setState({ subTab: 'requirements' })} aria-hidden>
                Requirements<i className={requirementsTabClasses} />
              </div>
            </div>
            <div className={classNames('QuestForm__userInfo', { active: subTab === 'landing' })}>
              <Landing
                questForm={questForm}
                onRichTextUpdate={this.handleRichTextUpdates}
                slugRef={el => { this.slugE = el; }}
                rteDefaultConfig={this.rte_default_config_landing}
              />
            </div>
            <div className={classNames('QuestForm__userInfo', { active: subTab === 'emails' })}>
              <EmailSettings
                questForm={questForm}
                emailFailureSentDate={emailFailureSentDate}
                emailReminderSentDate={emailReminderSentDate}
                questMeetsReminderMin={questMeetsReminderMin}
                onRichTextUpdate={this.handleRichTextUpdates}
              />
            </div>
            <div className={classNames('QuestForm__userInfo', { active: subTab === 'additional-questions' })}>
              <FieldArray
                name="stepsPage1"
                component={StepsGeneric}
                onStepSwap={this.swapStep}
                kind="additional-questions"
              />
            </div>
            <div className={classNames('QuestForm__userInfo', { active: subTab === 'requirements' })}>
              {
                (secondaryCreationQuest || !isStreamOrNewTypeQuest) ?
                  <FieldArray
                    name="requirements.beforeStream"
                    component={this.renderRequirements}
                    pointInQuest="beforeStream"
                  /> :
                  <> <h2> Before the Stream </h2>
                    <FieldArray
                      name="requirements.beforeStream"
                      component={this.renderRequirements}
                      pointInQuest="beforeStream"
                    />
                    <h2> During the Stream </h2>
                    <FieldArray
                      name="requirements.duringStream"
                      component={this.renderRequirements}
                      pointInQuest="duringStream"
                    />
                    <h2> After the Stream </h2>
                    <FieldArray
                      name="requirements.afterStream"
                      component={this.renderRequirements}
                      pointInQuest="afterStream"
                    />
                  </>
              }
            </div>
          </div>
          <div className="info-tab-wrap" style={(tab === 'faq') ? { display: 'block' } : { display: 'none' }}>
            <FieldArray
              name="faqs"
              component={FAQs}
              props={{
                onRemove: (fields, index) => {
                  fields.remove(index);
                  this.faqs = this.faqs.splice(index, 1);
                },
                onRichTextUpdate: this.handleRichTextUpdates
              }}
            />
          </div>
          <div className="info-tab-wrap" style={(tab === 'questDescription') ? { display: 'block' } : { display: 'none' }}>
            <FieldArray
              name="questDescriptions"
              component={QuestDescriptions}
              props={{
                onRemove: (fields, index) => {
                  fields.remove(index);
                  this.questDescriptions = this.questDescriptions.splice(index, 1);
                },
                onRichTextUpdate: this.handleRichTextUpdates
              }}
            />
          </div>
          <div className="info-tab-wrap" style={(tab === 'logs') ? { display: 'block' } : { display: 'none' }}>
            <LogsDisplay logs={this.props.adminActivityLogs.data} />
          </div>
          {(tab !== 'logs') && (
            <FormFooter
              showSave
              showPreview={action !== 'create'}
              questSlug={questForm.values?.slug}
              quest={quest}
            />
          )}
        </form>
        <UploadModal
          activeModal={activeModal}
          dropzoneActive={dropzoneActive}
          isLoading={isLoading}
          disableClick={disableClick}
          onClose={this.changeModalState}
          onDrop={(e, event) => this.onDrop(event, e)}
          onDragEnter={this.onDragEnter.bind(this)}
          onDragLeave={this.onDragLeave.bind(this)}
          dropzoneRef={(node) => { this.dropzoneRef = node; }}
          handleSelectedFile={this.handleSelectedFile}
        />
        {this.renderAchievementModal()}
      </div>
    );
  }
}
QuestForm.propTypes = {
  //  onSubmit: PropTypes.func.isRequired,
};

export default reduxForm({
  form: 'questForm',
  validate: validateQuestForm
})(QuestForm);
